var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M7.182 10.071l3.182-3.182-3.182-3.182L7.89 3l3.182 3.182L14.253 3l.708.707-3.182 3.182 3.182 3.182-.708.707-3.182-3.182-3.182 3.182z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }